<template>
  <section>
    <header
      class="d-flex add-surveys border-grey border-top-0 align-items-center justify-content-between"
    >
      <back-arrow />

      <div
        class="position-relative font-20 px-2 py-3 d-flex align-items-center justify-content-end"
      >
        <span class="cursor-pointer" @click="compareSurveys()">
          <img
            class="img-fluid"
            width="45"
            height="50"
            src="@/assets/images/shapes/add_more.svg"
            alt="add more surveys"
          />
          Add More Surveys
        </span>
        <div class="cursor-pointer ms-5">
          <span @click="$router.go(-1)"> <close-svg /> </span>
        </div>
        <!-- <div class="border-line w-100 position-absolute"></div> -->
      </div>
    </header>

    <div class="survey-charts-container">
      <compare-selected-surveys />
    </div>
  </section>
</template>

<script>
import CompareSelectedSurveys from "../../components/dashboard/compare-surveys/compare-selected-surveys.vue";

export default {
  components: {
    CompareSelectedSurveys,
  },
  computed: {
    surveyType() {
      return this.$route.query.type;
    },
  },
  methods: {
    compareSurveys() {
      this.$store.dispatch("mainStats/showSelectSurveys", this.surveyType);
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("mainStats/loadSurveysOFAllYears", {
        surveyType: this.surveyType.toLowerCase(),
      });
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.border-grey {
  border-top: $border-grey-60;
}
.add-surveys {
  color: $color-white;
}
.border-line {
  // width: 100%;
  border-bottom: $border-grey-60;
  // top: 205px;
  z-index: 10;
  top: 127px;
  left: 0;
}
</style>
